<script setup lang="ts">
import { useI18n } from "vue-i18n";
import type { AppError } from "../services/errors";
defineProps<{ error: AppError; actionLabel?: string }>();
defineEmits<{ retry: [] }>();
const { t } = useI18n();
</script>

<template>
  <section class="rounded-2xl bg-red-50 p-4 text-red-800" role="alert">
    <h2 class="font-semibold">{{ t("error_heading") }}</h2>
    <p class="mt-1 text-sm">{{ t(error.messageKey) }}</p>
    <p class="mt-2 text-xs">{{ error.code }}</p>
    <button
      v-if="actionLabel && error.retryable"
      type="button"
      class="secondary-button mt-4"
      @click="$emit('retry')"
    >
      {{ actionLabel }}
    </button>
  </section>
</template>
